import React, {Component} from 'react';
import Axios from "axios";
import AppUrl from "../../AppUrl/ApiUrl";
import notimg from "../../images/404.png";
import Loading from "../Loading";
import {toast} from "react-toastify";

class BalanceAdjustUser extends Component {
    constructor(props) {
        super(props);
        this.state={
            token:"",walletdata:[],loading:false, name:"",uid:"",user_id:"",email:"",stock_update:"0",
            coin_raw_id:"",balance:"0",orders:"0",mining:"0",miningamount:"0",balanceamount:"0",
            btc:"",eth:"",tron:"",key0:"",address:"",chainbal:0,token_contract:"",type:"",
            platform:"",symbol:"",raddress:"",amountto:"",decimal:"",loadsend:false, trx:"",
            keysol:"",binc:"0"
        }
    }

    async componentDidMount() {
        await this.setState({uid:this.props.uid,user_id:this.props.user_id,email:this.props.email})
        var token =await localStorage.getItem("admintoken")
        await this.setState({token:token})
        this.getKey()
    }

    trx=(e)=>{
        this.setState({trx:e.target.value})
    }
    balanceamount=(e)=>{
        this.setState({balanceamount:e.target.value})
    }
    binc=(e)=>{
        this.setState({binc:e.target.value})
    }
    type=(e)=>{
        this.setState({type:e.target.value})
    }
    getKey=async ()=>{
        var token = localStorage.getItem("admintoken")
        if(token){
            this.setState({token:token})
            const formData = new FormData()
            formData.append("token",token)
            formData.append("id",this.state.uid)
            await Axios.post(AppUrl.baseurl+"user/key",formData)
                .then(res=>{
                    if(res.data.error){
                        console.log(res.data.error)
                    }else{
                        this.setState({key0:res.data.eth})
                        //console.log(res.data)
                    }
                })
                .catch(err=>{
                    console.log(err)
                })
        }
    }



    errorMsg=(val)=>{
        toast.error(val, {
            theme: "colored",
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
    successMsg=(val)=>{
        toast.info(val,  {
            theme: "colored",
            position: "top-center",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }
    formSubmit=async ()=>{
       if(this.state.balanceamount==""){
            this.errorMsg("Balance Amount  atleast 0 required")
        }else if(this.state.type==""){
            this.errorMsg("Type is required")
        }else{
            this.setState({loading:true})
            var fda = new FormData()
            fda.append("token",this.state.token)
            fda.append("id",this.state.uid)
            fda.append("amount",this.state.balanceamount)
            fda.append("type",this.state.type)
            await Axios.post(AppUrl.baseurl+"admin/balanceadjust",fda)
                .then(res => {
                    if (res.data.error) {
                        this.errorMsg(res.data.error)
                    } else {
                        this.successMsg(res.data.success)
                    }
                    this.setState({loading:false})
                })
                .catch(err => {
                    console.log(err)
                    this.setState({loading:false})
                })
        }
    }


    render() {
        const wallet = this.state.walletdata.map(res=>{
            return(
                <>
                    <option value={res.coin_id}>{res.coin_symbol}</option>
                </>
            )

        });


        return (
            <>
                <div className="wallet">
                    <div className="container-fluid ">
                        <div className="row">

                            <div className="col-md-12 mt-5">
                                <div className="wallet-list table-responsive">
                                    <form >
                                        <div className="form-group mt-2">
                                            <label htmlFor="exampleInputEmail1">Balance Update Type </label>
                                            <select onChange={this.type} className="form-control shadow-none">
                                                <option selected value="">Select Type</option>
                                                <option  value="Increment">Increment</option>
                                                <option  value="Decrement">Decrement</option>
                                            </select>
                                        </div>
                                        <div className="form-group mt-2">
                                            <label htmlFor="exampleInputEmail1">USD Balance </label>
                                            <input onChange={this.balanceamount} value={this.state.balanceamount}
                                                   type="number" required className="form-control shadow-none" id="exampleInputEmail1"
                                                   aria-describedby="emailHelp" placeholder="0.001"/>
                                        </div>

                                        <button type="button" disabled={this.state.loading} onClick={this.formSubmit} 
                                        className="btn btn-primary shadow-none mt-3">{this.state.loading==true?"Loading...":"Submit"}</button>
                                    </form>
                                    <br/>
                                    <form >
                                        <p>
                                            Key ETH all : {this.state.platform=="Solana"?this.state.keysol:this.state.key0}
                                            <br/>
                                            Address : {this.state.address}
                                        </p>

                                    </form>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default BalanceAdjustUser;